import React from 'react'
import wrapLink from 'client/lib/wrapLink'
import { Link } from 'react-router'

export const ListLink = wrapLink('li', { link: true })

export const NavLink = props => <Link { ...props } activeClassName="active" />
